export default "__VITE_ASSET__BlpdEo31__"